import React from 'react';
import { BooleanInput, Edit, SimpleForm } from 'react-admin';

import ModalView from './ModalView';
import EditToolbar from './EditToolbar';

const redirect = (basePath, id) => `/customer/${id}/show/redirect`;

const PreferencesEdit = ({ openEdit, setOpenEdit, id }) => (
  <ModalView openEdit={openEdit} setOpenEdit={setOpenEdit}>
    <Edit
      basePath="customer"
      resource="customer"
      id={id}
      actions={null}
      undoable={false}
      title=" "
    >
      <SimpleForm
        redirect={redirect}
        toolbar={<EditToolbar setOpenEdit={setOpenEdit} />}
      >
        <BooleanInput source="is_opted_out_of_carfax_reporting" />
      </SimpleForm>
    </Edit>
  </ModalView>
);

export default PreferencesEdit;
